export default __webpack_public_path__ + "static/media/elmaser.a3585e28.webp";